// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CatalogCard-base__s2aNE{align-self:stretch}.CatalogCard-syncCaption__fg0wr{font:var(--font-caption-medium-400);font-feature-settings:var(--feature-settings-caption-medium-400);letter-spacing:var(--letter-spacing-caption-medium-400);color:var(--gray-a11)}.CatalogCard-brands__kZWIq{display:flex;flex-direction:column;gap:var(--size-1);max-height:var(--size-110);padding:var(--size-1);overflow-y:auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "CatalogCard-base__s2aNE",
	"syncCaption": "CatalogCard-syncCaption__fg0wr",
	"brands": "CatalogCard-brands__kZWIq"
};
export default ___CSS_LOADER_EXPORT___;
